export const CORRECTIONS_URL = "https://github.com/Livvux/fivemdocs-feedback/issues/new";

export function correctionUrl(articleUrl: string): string {
  const article = new URL(articleUrl);
  if (article.origin !== "https://fivemdocs.com") throw new Error("Expected a public FiveM Docs article");
  const params = new URLSearchParams({
    template: "correction.yml",
    page: article.origin + article.pathname,
  });
  return `${CORRECTIONS_URL}?${params}`;
}
